import React from "react";
import { bool, shape } from "prop-types";
import Inline from "../Inline";
import DropdownTriangle from "./Triangle";
import { classes } from "../utils/classes";
import { prevent } from "../utils/handlers";
import { colorPropTypes } from "../props/sx";
import { spacingPropTypes } from "../props/spacing";
import Link from "../Link";

const DropdownTitle = ({
	isOpen = false,
	triangle = true,
	className = "",
	children,
	childrenProps,
	triangleProps = {},
	...props
}) => {
	return (
		<Inline
			className={classes("dropdown-title", isOpen && "dropdown-title--open", className)}
			{...props}
		>
			<Inline {...childrenProps}>
				<Inline className="dropdown-title__text">{children}</Inline>
				{triangle ? <DropdownTriangle isOpen={isOpen} {...triangleProps} /> : null}
			</Inline>
		</Inline>
	);
};

DropdownTitle.propTypes = {
	isOpen: bool,
	triangle: bool,
	...Inline.propTypes,
	childrenProps: shape({
		...Inline.propTypes,
	}),
	triangleProps: shape({
		color: colorPropTypes,
		isOpenColor: colorPropTypes,
		spacing: spacingPropTypes,
	}),
};

const DropdownTitleLink = props => (
	<DropdownTitle isBaseClassName={false} Tag={Link} {...props} onClick={prevent} />
);

DropdownTitle.Link = DropdownTitleLink;

export default DropdownTitle;
